import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { Paths } from '../../../../enums';
import { SharedService, CommonService, CommonAPIService } from '../../../../services';

@Component({
  selector: 'app-online-training-courses',
  standalone: false,
  templateUrl: './online-training-courses.component.html',
  styleUrl: './online-training-courses.component.scss'
})
export class OnlineTrainingCoursesComponent {
  courseCategoryData: any[] = [];
  imageUrl: string = environment.imageURL;

  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private commonAPIService: CommonAPIService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getCoursesCategoryList();
  }
  
  async getCoursesCategoryList() {
    try {
      this.sharedService.setApiCall(true);
      this.commonService.resetAPIFlag('getCoursesCategoryActive', false);
      const response: any = await this.commonAPIService.getCall('getCoursesCategoryActive', '');
      this.commonService.resetAPIFlag('getCoursesCategoryActive', false);
      switch (response.status) {
        case 1:
          if (response.data) {
            this.courseCategoryData = response?.data;
            this.sharedService.setApiCall(false);
          }
          else {
            this.courseCategoryData = [];
            this.sharedService.setApiCall(false);
          }
          break;
        case 0:
          this.courseCategoryData = [];
          this.sharedService.setApiCall(false);
          break;
      }
    } catch (error) {
      console.error('Error getting Courses details:', error);
    }
  }

  getSubCategory(item: any) {
    this.commonAPIService.data = item;
    localStorage.setItem('serviceData', JSON.stringify(item));
    this.router.navigate([`${Paths.courseSubCategory}`]);
  }
}
